import React from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
const ManageQuickPayDiscountTerms = () => {
    const { t } = useTranslation();
    const breadcrumbs = {
        pages: [
            {
                name: t('PRICING'),
                href: `/pricing/quick-pay`,
                current: true,
            },
            {
                name: t('QUICK_PAY'),
                href: `/pricing/quick-pay`,
                current: true,
            },
        ],
    };
    return (React.createElement(LayoutWithSidebar, { className: "mt-4 mb-4", title: t('MANAGE_REFERENCE_NUMBERS'), breadcrumbs: breadcrumbs }));
};
export default ManageQuickPayDiscountTerms;
